import { forwardRef, LegacyRef, MouseEventHandler } from 'react';
import DatePicker, { DatePickerProps, registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Input, InputGroup, InputLeftElement } from '@chakra-ui/react';
import { CalendarIcon } from '@ae/icons';
import { fr } from 'date-fns/locale/fr';

type Props = DatePickerProps;
registerLocale('fr', fr);

export const UIDatePicker = ({
  dateFormat = 'dd / MM / yyyy',
  ...datePickerProps
}: Props & DatePickerProps) => {
  // DOC : https://reactdatepicker.com/#example-custom-input
  const CustomInput = forwardRef(
    (
      {
        value,
        onClick,
        name,
      }: { value?: string; onClick?: MouseEventHandler; name?: string },
      ref: LegacyRef<HTMLInputElement>
    ) => (
      <InputGroup onClick={onClick}>
        <InputLeftElement pointerEvents="none">
          <CalendarIcon />
        </InputLeftElement>
        <Input ref={ref} value={value} aria-label={name} />
      </InputGroup>
    )
  );

  return (
    <DatePicker
      {...datePickerProps}
      dateFormat={dateFormat}
      locale="fr"
      customInput={<CustomInput />}
    />
  );
};
